// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__1xP80","icon":"EnquiryForm_icon__2T--P","heading":"EnquiryForm_heading__2bMZV","field":"EnquiryForm_field__VpIEn","error":"EnquiryForm_error__QaqGK"};